var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 4.5H25.3333C26.8061 4.5 28 5.69391 28 7.16667V25.8333C28 27.3061 26.8061 28.5 25.3333 28.5H6.66667C5.19391 28.5 4 27.3061 4 25.8333V7.16667C4 5.69391 5.19391 4.5 6.66667 4.5ZM10.6667 24.5C11.0349 24.5 11.3333 24.2015 11.3333 23.8333V14.5C11.3333 14.1319 11.0349 13.8333 10.6667 13.8333H8.66667C8.29848 13.8333 8 14.1319 8 14.5V23.8333C8 24.2015 8.29848 24.5 8.66667 24.5H10.6667ZM9.66667 12.5C8.56209 12.5 7.66667 11.6046 7.66667 10.5C7.66667 9.39543 8.56209 8.5 9.66667 8.5C10.7712 8.5 11.6667 9.39543 11.6667 10.5C11.6667 11.6046 10.7712 12.5 9.66667 12.5ZM23.3333 24.5C23.7015 24.5 24 24.2015 24 23.8333V17.7C24.0433 15.5811 22.4768 13.7727 20.3733 13.5133C18.9027 13.379 17.4777 14.0659 16.6667 15.3V14.5C16.6667 14.1319 16.3681 13.8333 16 13.8333H14C13.6319 13.8333 13.3333 14.1319 13.3333 14.5V23.8333C13.3333 24.2015 13.6319 24.5 14 24.5H16C16.3681 24.5 16.6667 24.2015 16.6667 23.8333V18.8333C16.6667 17.7288 17.5621 16.8333 18.6667 16.8333C19.7712 16.8333 20.6667 17.7288 20.6667 18.8333V23.8333C20.6667 24.2015 20.9652 24.5 21.3333 24.5H23.3333Z",
    fill: "url(#paint0_linear_1637_376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1637_376",
    x1: 16,
    y1: 26.0172,
    x2: 16,
    y2: 8.01724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked_in.77ae300f051132d0e4780cb5fcfb8bcf.svg";
export { ForwardRef as ReactComponent };